var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#radio-unchecked--qkqb9';
                    var viewUrl = 'sprites.svg#view-radio-unchecked--qkqb9';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };